<template>
	<div class="page">
		<div title="talentTemplate" is='headered'></div>
		<div class="public_title">
			<div>青年阶段——</div>
			<div>项目管理本科在线视频慕课</div>
			<div class="public_titleImg">
				<img src="../../assets/公众号.png"/>
				<div>青少年创新项目管理集训营</div>
			</div>
		</div>	
		<div class="young3_text">项目管理专业的高校本科教学和国际认证IPMP有50%以上需要掌握理论知识，公司开发出针对高校项目管理专业的视频慕课云课堂，拥有十门专业视 频课，包括成本管理、系统工程、风险管理、时间管理、采购管理等专业课。每门视频课程时长5-8小时，可供5000人在线学习。日均在线学习量200 人次/门课，根据学期内学生完成线上100小时以上和70小时以上的学习量，设置不同额度的奖学金予以鼓励。慕课平台网址https://bjpm.yunqike. 163.com</div>
		<div class="young3_box">
			<div class="young_row1">
				<img src="../../assets/stageImg/stage4_1.png"/>
				<img src="../../assets/stageImg/stage4_22.png"/>
			</div>
			<div class="young_row2">
				<div class="young_row2_1">
					<img src="../../assets/stageImg/stage4_5.png"/>
					<img src="../../assets/stageImg/stage4_6.png"/>	
				</div>
				
				<div class="young_row2_2">
					<img src="../../assets/stageImg/stage4_3.png"/>
					<img  src="../../assets/stageImg/stage4_4.png"/>
					<img src="../../assets/stageImg/stage4_7.png"/>
					<img src="../../assets/stageImg/stage4_8.png"/>
				</div>
			</div>
		</div>
		<div is='footed'></div>
	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {}
		}
	}
</script>

<style scoped="scoped">
	.public_title {
		width: 1200px;
		margin: 0 auto;
		margin-top: 90px;
		margin-bottom: 60px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}
	
	.public_title div {
		line-height: 48px;
		color: #1F2329;
		font-size: 36px;
		text-align: left;
		font-weight: bold;
	}
	
	.public_title>div:nth-child(2) {
		color: #0080FF;
		margin-right: 50px;
	}
	.public_title .public_titleImg{
		width: 200px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.public_title .public_titleImg img{
		width: 100px;
		height: 100px;
	}
	.public_title .public_titleImg div{
		font-size: 14px;
		line-height: 20px;
		width: 200px;
		text-align: center;
		color: #333;
	}
	.young3_text{
		width: 1200px;
		margin: 0 auto;
		line-height: 30px;
		font-size: 18px;
		text-align: left;
		color: #51565D;	
		margin-bottom: 60px;
		text-indent: 2em;
	}
	.young3_box{
		width: 996px;
		margin: 0 auto;
	}
	.young_row1{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 60px;
	}
	.young_row1>img{
		width: 486px;
		height: 290px;
	}
	.young_row2{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
		margin-bottom: 60px;
	}
	.young_row2 .young_row2_1{
		width: 350px;
	}
	.young_row2 .young_row2_1 img{
		width: 350px;
		margin-bottom: 30px;
	}
	.young_row2 .young_row2_1 img:nth-child(2){
		margin-bottom: 0px;
	}
	.young_row2 .young_row2_2{
		width: 600px;
	}
	.young_row2 .young_row2_2 img{
		width: 600px;
		margin-bottom: 125px;
	}
	.young_row2 .young_row2_2 img:nth-child(4){
		margin-bottom: 0px;
	}
</style>


// WEBPACK FOOTER //
// src/views/phaseList/youngStage3.vue